module.exports = __webpack_public_path__ + "img/clerk_route_tarif_2.5623ce62.png";